import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".element-mediascrollablecontent").forEach((el) => {
  const sectionsPlaceholder = el.querySelector(".scroll-sections-placeholder");
  const sectionPlaceholders = el.querySelectorAll(".scroll-section-placeholder");
  const sections = el.querySelectorAll(".scroll-section");
  const contents = el.querySelectorAll(".scroll-content");
  const actions = el.querySelector(".element-actions");

  if (actions) {
    gsap.set(actions, { yPercent: 40, opacity: 0 });
  }

  contents.forEach((content) => {
    const height = content.scrollHeight;
    const styles = window.getComputedStyle(content);
    const margin = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
    const padding = parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);

    content.setAttribute("data-height", height + margin + padding);
  });

  gsap.set(el.querySelectorAll(".scroll-section-item"), { opacity: 0.4 });
  gsap.set(contents, { height: 0 });

  const timeline = gsap.timeline({
    paused: true,
    scrollTrigger: {
      trigger: el.querySelector(".scroll-sections"),
      start: "top center",
      end: () => {
        return `${sectionsPlaceholder.offsetHeight}px center`;
      },
      scrub: true,
      markers: false,
    },
    onReverseComplete: () => {
      if (actions) {
        gsap.set(actions, { yPercent: 40, opacity: 0 });
      }
    },
    onComplete: () => {
      if (actions) {
        gsap.to(actions, { yPercent: 0, opacity: 1 });
      }
    },
  });

  contents.forEach((content) => {
    timeline.to(content, { height: content.dataset.height });
  });

  sectionPlaceholders.forEach((section) => {
    const target = Array.from(sections).filter((el) => el.dataset.index === section.dataset.index);

    ScrollTrigger.create({
      trigger: section,
      start: "top center",
      end: "top center",
      scrub: true,
      markers: false,
      onEnter: () => {
        gsap.to(target[0].querySelectorAll(".scroll-section-item"), { opacity: 1 });
      },
      onEnterBack: () => {
        gsap.to(target[0].querySelectorAll(".scroll-section-item"), { opacity: 0.4 });
      },
    });
  });

  ScrollTrigger.refresh();
});
